import { EntitiesStore } from './entities-store.abstract';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';


/**
 * Links of indoor calendar model.
 *
 * @export
 * @interface Links
 */
export interface Links {
  'E-Mail': string;
  'Registration URL': string;
  Web: string;
}

/**
 * Indoor calendar model.
 *
 * @export
 * @interface ISeriesStageIndoor
 */
export interface ISeriesStageIndoor {
  ID: number;
  Name: string;
  NameShort: string;
  Venue: string;
  Place: string;
  Country: string;
  CountryName: string;
  DFrom: string;
  DTo: string;
  ComLevel: number;
  ComSubLevel: number;
  ComDis: number;
  Level: string;
  SubLevel: string;
  Stage: number;
  isFinal: boolean;
  StageLevel: string;
  Links: Links;
}

/**
 * A store for series stage in indoor calendar.
 *
 * @export
 * @class SeriesStageIndoorStore
 * @extends {EntitiesStore<ISeriesStageIndoor>}
 */
export class SeriesStageIndoorStore extends EntitiesStore<ISeriesStageIndoor> {
  constructor(injector: Injector) {
    super('SERIESSTAGES', injector.get(HttpClient));
  }
}
